import React, { useState } from "react";
import { styled } from '@mui/material/styles';
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import { Button, Card, Chip, Dialog, DialogActions, DialogContent, Divider, DialogTitle, IconButton, InputBase, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableRow, Box, Grid, Typography, TextField, FormHelperText } from "@mui/material";
import SearchIcon from "src/svgComponents/SearchIcon";
import UserListHead from "src/components/user/UserListHead";
import { ORDERS } from "src/api/axios";
import { useQuery } from "react-query";
import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { TablePagination } from "@material-ui/core";
import { fDate } from "../../../src/utils/formatTime";
import PreviewIcon from '@mui/icons-material/Preview';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import AppTooltip from "src/components/common/AppTooltip";
import moment from "moment";
import CloseIcon from '@mui/icons-material/Close';
import { LoadingButton } from "@mui/lab";
import { Form, FormikProvider, useFormik } from "formik";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import LoadingScreen from "src/components/LoadingScreen";

const PendingOrder = () => {
   const [tableData, setTableData] = useState([]);
   const [page, setPage] = useState(0);
   const [rowsPerPage, setRowsPerPage] = useState(10);
   const [order, setOrder] = useState('desc');
   const [orderBy, setOrderBy] = useState('createdAt');
   const [filterName, setFilterName] = useState('');
   const [open, setIsOpen] = useState(false);
   const [openPickupDialog, setIsOpenPickupDialog] = useState(false);
   const [deleteAlert, setDeleteAlert] = useState(false);
   const [completeAlert, setCompleteAlert] = useState(false);
   const [alertTitle, setAlertTitle] = useState('')
   const [buttonTitle, setButtonTitle] = useState('')
   const [rejectAlert, setRejectAlert] = useState(false);
   const [deleteId, setDeleteId] = useState('');
   const [orderDetailData, setOrderDetails] = useState('');
   const [loading, setLoding] = useState(true);
   const axiosPrivate = useAxiosPrivate();
   const [buttonLoading, setButtonLoding] = useState(false);
   const { enqueueSnackbar } = useSnackbar();
   const [pickupStartTime, setPickupStartTimeValue] = useState();
   const [pickupEndTime, setPickupEndTimeValue] = useState();
   const [btnFlag, setBtnFlag] = useState(false);
   const StyledTableRow = styled(TableRow)(({ theme }) => ({
      '&:nth-of-type(odd)': {
         backgroundColor: '#ffffff',
      },
      '&:nth-of-type(even)': {
         background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
      },
      // hide last border
      '& td, & th': {
         border: 0,
      },
   }));

   const TABLE_HEAD = [
      { id: 'name', label: 'Customer Name', alignRight: false },
      { id: 'email', label: 'Customer Email', alignRight: false },
      { id: 'mobile', label: 'Customer Mobile', alignRight: false },
      { id: 'order_id', label: 'Order Id', alignRight: false },
      { id: 'order on', label: 'Order on', alignRight: false },
      { id: 'order amount', label: 'Order amount', alignRight: false },
      { id: 'is_pickup', label: 'Order Pick Up', alignRight: false },
      { id: 'delivery_provider', label: 'Delivery Provider', alignRight: false },
      { id: 'is_pickup', label: 'Order Pick Time', alignRight: false },
      { id: 'verification_otp', label: 'OTP', alignRight: false },
      { id: 'status', label: 'Status', alignRight: false },
      { id: 'action', label: 'Action', alignRight: false },
   ];
   const ORDER_TABLE_HEAD = [
      { id: 'item_name', label: 'Item Name', alignRight: false },
      { id: 'quantity', label: 'Quantity', alignRight: false },
      { id: 'total', label: 'Total', alignRight: false },
   ];
   function descendingComparator(a, b, orderBy) {
      if (b[orderBy] < a[orderBy]) {
         return -1;
      }
      if (b[orderBy] > a[orderBy]) {
         return 1;
      }
      return 0;
   }

   function getComparator(order, orderBy) {
      return order === 'desc'
         ? (a, b) => descendingComparator(a, b, orderBy)
         : (a, b) => -descendingComparator(a, b, orderBy);
   }
   function applySortFilter(array, comparator) {
      const stabilizedThis = array.map((el, index) => [el, index]);
      stabilizedThis.sort((a, b) => {
         const order = comparator(a[0], b[0]);
         if (order !== 0) return order;
         return a[1] - b[1];
      });
      return stabilizedThis.map((el) => el[0]);
   }

   const handleFilterByName = (event) => {
      setFilterName(event.target.value.trim());
      setPage(0);
      getPendingOrders(page, filterName)
      refetch();
   };
   const handleRequestSort = (event, property) => {
      const isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
   };
   const handleChangePage = (event, newPage) => {
      setPage(newPage);
   };
   const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
   };

   async function getPendingOrders(page, filterName) {
      const response = await axiosPrivate.get(ORDERS.getOrderById, { params: { status: "0,1,4,5", page: page + 1, search: filterName, limit: rowsPerPage } })
      return response.data[0];
   }

   const { data: pendingOrderList, refetch } = useQuery(['pendingOrderList', page, filterName], () => getPendingOrders(page, filterName), { keepPreviousData: true, })

   useEffect(() => {
      if (pendingOrderList) {
         setTableData(pendingOrderList.data);
         setRowsPerPage(pendingOrderList?.metadata.length != 0 ? pendingOrderList?.metadata[0].limit : 10);
      }
      if (pendingOrderList?.metadata.length != 0 && pendingOrderList?.metadata[0].hasMoreData == true) {
         getPendingOrders(page + 1);
      }
      setTimeout(() => {
         setLoding(false);
      }, 1000)
   }, [pendingOrderList])


   const PendingOrder = applySortFilter(tableData, getComparator(order, orderBy));

   // VIEW Dialoge  
   const handleOrderView = (data) => {
      if (data) {
         setIsOpen(!open);
         setOrderDetails(data)
      }
   }
   const handleCloseOrderView = () => {
      setIsOpen(!open);
      setOrderDetails('');
   }
   // Delete order
   const handleOpen = (id) => {
      setDeleteId(id)
      setDeleteAlert(!deleteAlert);
   }
   const handleClose = () => {
      setDeleteAlert(!deleteAlert);
   }
   const handleDeleteOrder = async () => {
      if (deleteId) {
         const response = await axiosPrivate.delete(ORDERS.deletePendingOrder + deleteId)
         if (response?.data?.message) {
            enqueueSnackbar(response?.data?.message, {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 2000,
            });
            setDeleteAlert(!deleteAlert);
         }
      }
      refetch()
   }

   // Accept Order or inProgress Order
   const handleAcceptAlert = async (row) => {
      setBtnFlag(false)
      if (row.is_pickup === true) {
         setFieldValue('message', "")
         setIsOpenPickupDialog(true)
         var date = new Date();
         setPickupStartTimeValue(date)
         var newDateObj = moment(date).add(60, 'm').toDate();
         setPickupEndTimeValue(newDateObj);
      } else {
         setCompleteAlert(true)
      }
      setOrderDetails(row);
      setAlertTitle('Accept')
      setButtonTitle('Accept')
   }
   const handleCloseCompleteAlert = () => {
      setCompleteAlert(!completeAlert);
      setBtnFlag(false)
      // setOrderDetails('');
   }
   const AcceptOrderStatus = async function () {
      if (orderDetailData) {
         const data = {
            "orderId": orderDetailData._id,
            "status": orderDetailData.status === 0 ? 1
               : orderDetailData?.is_pickup ? 2
                  : !orderDetailData?.is_pickup && orderDetailData.delivery_by == 1 && orderDetailData.status == 1 ? 2
                     : 0,
         }
         await changeOrderStatus(data)
         refetch()
      }
      setCompleteAlert(!completeAlert);
   }
   // Complete Order
   const handleCompleteOrder = async (row) => {
      setOrderDetails(row);
      setAlertTitle('Complete')
      setCompleteAlert(true)
      setBtnFlag(false)
      setButtonTitle('Complete')
   }

   // Reject Order
   const handleCloseRejectAlert = () => {
      setRejectAlert(!rejectAlert);
      setOrderDetails('');
   }
   // const handleOpenRejectAlert = async (row) => {
   //    setOrderDetails(row);
   //    setRejectAlert(true)
   // }

   const handleRejectOrder = async () => {
      const data = {
         "orderId": orderDetailData._id,
         "status": orderDetailData.status === 0 ? 3 : 0
      }
      await changeOrderStatus(data);
      refetch()
   }

   // Common Change Status Api call
   const changeOrderStatus = async (data) => {
      setBtnFlag(true)
      await axiosPrivate
         .put(ORDERS.changeOrderStatus, data)
         .then((e) => {
            refetch();
            setButtonLoding(false);
            setIsOpenPickupDialog(false)
            setIsOpen(false)
            enqueueSnackbar(e?.data?.message, {
               variant: "success",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 3000,
            });
         })
         .catch((e) => {
            setButtonLoding(false);
            enqueueSnackbar(e?.response?.data?.message, {
               variant: "error",
               anchorOrigin: { vertical: "top", horizontal: "right" },
               autoHideDuration: 3000,
            });
         });
   }

   const handlePickupStartTime = (startTime) => {
      setPickupStartTimeValue(startTime)
      var start_date = new Date(startTime.valueOf())
      var newDateObj = moment(start_date).add(60, 'm').toDate();
      setPickupEndTimeValue(newDateObj);
   }

   const formik = useFormik({
      initialValues: {
         pickup_start_time: "",
         pickup_end_time: ""
      },
      // validationSchema: completedSchema,
      onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {

         const informationObj = {
            pickup_start_time: pickupStartTime,
            pickup_end_time: pickupEndTime,
         };

         const data = {
            "orderId": orderDetailData._id,
            "status": orderDetailData.status === 0 ? 1
               : orderDetailData?.is_pickup ? 2
                  : !orderDetailData?.is_pickup && orderDetailData.delivery_by == 1 && orderDetailData.status == 1 ? 2
                     : 0,
            "pickup_start_time": informationObj.pickup_start_time,
            "pickup_end_time": informationObj.pickup_end_time
         }

         setButtonLoding(true)
         await changeOrderStatus(data)
         resetForm();
         setSubmitting(false);
      },
   });

   const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps, resetForm } = formik;

   const handleClosePickUpOrder = () => {
      setIsOpenPickupDialog(!openPickupDialog)
      resetForm();
   }

   return (
      <>
         <LoadingScreen loading={loading} />
         <div className="dashboard_header mb-4">
            <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Pending Orders</h4>
            <Paper component="form" className='dashboard_searchbox col-lg-4'>
               <IconButton>
                  <SearchIcon />
               </IconButton>
               <InputBase
                  fullWidth
                  sx={{ flex: 1 }}
                  placeholder="search ..."
                  onChange={(e) => handleFilterByName(e)}
                  onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
               />
            </Paper>
         </div>

         {/* List */}
         <Card>
            <TableContainer>
               <Table>
                  <UserListHead
                     headLabel={TABLE_HEAD}
                     rowCount={0}
                     onRequestSort={handleRequestSort}
                  />
                  {PendingOrder?.length > 0 ?
                     <TableBody>
                        {PendingOrder.map((row, index) => {
                           return (
                              <StyledTableRow key={row._id}>
                                 <TableCell component="th" scope="row"> {row?.user_data?.firstname ? row?.user_data?.firstname + ' ' + row?.user_data?.lastname : '-'} </TableCell>
                                 <TableCell component="th" scope="row"> {row?.user_data?.email ?? '-'} </TableCell>
                                 <TableCell component="th" scope="row"> {row?.user_data?.mobile ?? '-'} </TableCell>
                                 <TableCell component="th" scope="row"> {row?.order_id ?? '-'} </TableCell>
                                 <TableCell component="th" scope="row"> {fDate(row?.createdAt)} </TableCell>
                                 <TableCell component="th" scope="row"> £{row?.total_amount?.toFixed(2)} </TableCell>
                                 <TableCell component="th" scope="row"> {row.is_pickup == true ? 'Yes' : 'No'} </TableCell>
                                 <TableCell component="th" scope="row"> {row.is_pickup == false && row.delivery_by == 0 ? "Binox Delivery" : row.delivery_by == 1 ? "Self Delivery" : "-"} </TableCell>
                                 <TableCell component="th" scope="row">
                                    {
                                       row.is_pickup == true && row.pickup_start_time ?
                                          <span className="d-flex text-nowrap">{moment(row.pickup_start_time).format("hh:mm A").toLocaleString() + ' to ' + moment(row.pickup_end_time).format("hh:mm A").toLocaleString()}</span> : '-'
                                    }
                                 </TableCell>
                                 <TableCell component="th" scope="row"> {row?.verification_otp} </TableCell>
                                 <TableCell>
                                    <Stack direction="row" spacing={3}>
                                       {
                                          row.status === 0 ?
                                             <Chip variant="contained" label="Pending" className="app_status_chip pending" />
                                             : row.status === 1 ?
                                                <Chip variant="" color="info" className="app_status_chip" label="In Progress" />
                                                : row.status === 2 ?
                                                   <Chip variant="" className="app_status_chip reject" label="Complete" />
                                                   : row.status === 4 ?
                                                      <Chip variant="" color="default" className="app_status_chip" label="Ready For Deliver" />
                                                      : row.status === 5 ?
                                                         <Chip variant="" color="default" className="app_status_chip" label="Out For Delivery" />
                                                         : row.status === 6 ?
                                                            <Chip variant="" color="default" className="app_status_chip reject" label="Returned" />
                                                            : <Chip variant="" className="app_status_chip reject" label="Rejected" />
                                       }
                                    </Stack>
                                 </TableCell>
                                 <TableCell component="th" scope="row">
                                    <Stack direction="row" sx={{ backgroundColor: '#0000001a', borderRadius: 25, p: 0.4 }} spacing={0.5} divider={<Divider orientation="vertical" flexItem />}>
                                       {row?.status === 0 ?
                                          <Box>
                                             <AppTooltip title="Accept Order" placement="bottom">
                                                <IconButton sx={{ width: 32, height: 32, p: 2, minWidth: 'unset' }} onClick={() => handleAcceptAlert(row)}>
                                                   <CheckCircleOutlineOutlinedIcon color="success" />
                                                </IconButton>
                                             </AppTooltip>
                                          </Box>
                                          :
                                          row.is_pickup || (!row.is_pickup && row.delivery_by == 1 && row?.status === 1) ?
                                             <Box>
                                                <AppTooltip title="Complete Order" placement="bottom">
                                                   <IconButton sx={{ width: 32, height: 32, p: 2, minWidth: 'unset' }} onClick={() => handleCompleteOrder(row)}>
                                                      <TaskAltOutlinedIcon style={{ color: '#0288D1' }} />
                                                   </IconButton>
                                                </AppTooltip></Box> :
                                             <></>
                                       }
                                       <Box>
                                          <AppTooltip title="View Order" placement="bottom">
                                             <IconButton sx={{ width: 32, height: 32, p: 2, minWidth: 'unset' }}
                                                onClick={() => handleOrderView(row)} >
                                                <PreviewIcon style={{ color: '#282a3a' }} />
                                             </IconButton>
                                          </AppTooltip></Box>
                                       {/* <Box><AppTooltip title="Delete Order" placement="bottom">
                                          <IconButton sx={{ width: 32, height: 32, p: 2, minWidth: 'unset' }} onClick={() => handleOpen(row._id)} ><DeleteOutlinedIcon style={{ color: '#ff0000' }} /></IconButton>
                                       </AppTooltip></Box> */}
                                       {/* {
                                          row?.status === 0 ?
                                             <Box><AppTooltip title="Reject Order" placement="bottom">
                                                <IconButton sx={{ width: 32, height: 32, p: 2, minWidth: 'unset' }} onClick={() => handleOpenRejectAlert
                                                   (row)}  ><NotInterestedOutlinedIcon style={{ color: '#ff0000' }} /></IconButton>
                                             </AppTooltip>
                                             </Box> : ''
                                       } */}
                                    </Stack>
                                 </TableCell>
                              </StyledTableRow>
                           )
                        })}
                     </TableBody>
                     :
                     <TableBody>
                        <TableRow>
                           <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                              <span className="app_text_16_semibold">No Data Found</span>
                           </TableCell>
                        </TableRow>
                     </TableBody>}
               </Table>
            </TableContainer>
            <TablePagination
               component="div"
               rowsPerPageOptions={[10, 20, 50, 100]}
               count={pendingOrderList?.metadata.length != 0 ? pendingOrderList?.metadata[0].total : 0}
               rowsPerPage={rowsPerPage}
               page={page}
               onPageChange={handleChangePage}
               onRowsPerPageChange={handleChangeRowsPerPage}
            />
         </Card>

         {/* Delete Alert Dialoge */}
         <Dialog
            open={deleteAlert}
            onClose={handleClose}
            aria-labelledby="responsive-dialog-title"
         >
            <DialogTitle id="responsive-dialog-title" className='m-auto'>
               {"Are you sure you want to delete?"}
            </DialogTitle>
            <DialogContent>
               <Stack direction={"row"} spacing={2} justifyContent={'center'}>
                  <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                     Cancel
                  </Button>
                  <Button className="theme_button" variant="contained" onClick={handleDeleteOrder} autoFocus>
                     Delete
                  </Button>
               </Stack>
            </DialogContent>
         </Dialog>
         {/* Alert Complete dialog */}
         <Dialog
            open={completeAlert}
            onClose={handleCloseCompleteAlert}
            aria-labelledby="responsive-dialog-title"
         >
            <DialogTitle id="responsive-dialog-title" className='m-auto'>
               Are you sure you want to {alertTitle} Order?
            </DialogTitle>
            <DialogContent>
               <Stack direction={"row"} spacing={2} justifyContent={'center'}>
                  <Button className="theme_button_view" variant="contained" autoFocus onClick={handleCloseCompleteAlert}>
                     Cancel
                  </Button>
                  <Button className="theme_button" variant="contained" onClick={AcceptOrderStatus} autoFocus disabled={btnFlag}>
                     {buttonTitle}
                  </Button>
               </Stack>
            </DialogContent>
         </Dialog>
         {/* Alert Reject dialog */}
         <Dialog
            open={rejectAlert}
            onClose={handleCloseRejectAlert}
            aria-labelledby="responsive-dialog-title"
         >
            <DialogTitle id="responsive-dialog-title" className='m-auto'>
               {"Are you sure you want to Complete Order?"}
            </DialogTitle>
            <DialogContent>
               <Stack direction={"row"} spacing={2} justifyContent={'center'}>
                  <Button className="theme_button_view" variant="contained" autoFocus onClick={handleCloseRejectAlert}>
                     Cancel
                  </Button>
                  <Button className="theme_button" variant="contained" onClick={handleRejectOrder} autoFocus>
                     Reject
                  </Button>
               </Stack>
            </DialogContent>
         </Dialog>
         {/* Order Detail Dialoge */}
         <Dialog fullWidth open={open} >
            <DialogTitle>Order Details</DialogTitle>
            <DialogContent>
               <Grid container spacing={2} sx={{ py: 2 }}>
                  <Grid item xs={12}>
                     <Divider
                        sx={{
                           borderColor: "#A6A6A6",
                        }}
                     />
                  </Grid>
                  <Grid item xs={12}>
                     <Box
                        display={"flex"}
                        justifyContent={"space-between"}
                        alignItems="center"
                     >
                        <Box>
                           <Typography className="app_text_16_semibold">
                              Order
                           </Typography>
                        </Box>
                        <Box>
                           {orderDetailData?.status === 0 && (
                              <Chip
                                 label="Pending"
                                 style={{ backgroundColor: "#E4A11B", color: "#fff" }}
                              />
                           )}
                           {orderDetailData?.status === 1 && (
                              <Chip
                                 label="In Progress"
                                 style={{ backgroundColor: "#54B4D3", color: "#fff" }}
                              />
                           )}
                           {orderDetailData?.status === 2 && (
                              <Chip
                                 label="Completed"
                                 style={{ backgroundColor: "#14A44D", color: "#fff" }}
                              />
                           )}
                           {orderDetailData?.status === 3 && (
                              <Chip
                                 label="Cancelled"
                                 style={{ backgroundColor: "#DC4C64", color: "#fff" }}
                              />
                           )}
                           {orderDetailData?.status === 4 && (
                              <Chip
                                 label="Ready For Deliver"
                                 style={{ backgroundColor: "#17A2B8", color: "#fff" }}
                              />
                           )}
                           {orderDetailData?.status === 5 && (
                              <Chip
                                 label="Out For Delivery"
                                 style={{ backgroundColor: "#007BFF", color: "#fff" }}
                              />
                           )}
                           {orderDetailData?.status === 6 && (
                              <Chip
                                 label="Returned"
                                 style={{ backgroundColor: "#800080", color: "#fff" }}
                              />
                           )}
                        </Box>
                     </Box>
                     {orderDetailData?.items ? (
                        <Box marginTop={2} boxShadow={"0px 1px 3px #A6A6A6"}>
                           <Table>
                              {orderDetailData?.items.map((row) => {
                                 return (
                                    <StyledTableRow key={row._id}>
                                       <TableCell>
                                          {row.item_name ? (
                                             <Stack display={"flex"} alignItems="flex-start" spacing={3} direction={"row"} >
                                                <Box
                                                   sx={{
                                                      height: "80px",
                                                      width: "80px",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      borderRadius: "12px",
                                                      overflow: "hidden",
                                                   }}
                                                >
                                                   <img src={row?.image ? process.env.REACT_APP_PROFILE_URL + (orderDetailData?.category_type === '2' ? "groceryItem/" : "foodItem/") + row?.image : ""} alt="" style={{ height: "100%", width: "100%", objectFit: "cover", objectPosition: "center", }}
                                                   />
                                                </Box>
                                                <Box>
                                                   <h6>{row?.item_name}</h6>
                                                   <p>{row?.quantity + "x"}</p>
                                                </Box>
                                             </Stack>
                                          ) : (
                                             ""
                                          )}
                                       </TableCell>
                                       <TableCell style={{ display: "flex", alignItems: "center", justifyContent: "right" }}
                                       >
                                          <Typography className="app_text_14_semibold"> £{row?.total?.toFixed(2)} </Typography>
                                       </TableCell>
                                    </StyledTableRow>
                                 );
                              })}
                           </Table>
                        </Box>
                     ) : (
                        ""
                     )}
                  </Grid>
                  <Grid item xs={12}>
                     <Typography className="app_text_16_semibold">
                        Order Details
                     </Typography>
                     <Box sx={{ border: "1px solid gainsboro", padding: "16px" }} >
                        <Stack spacing={2}>
                           <Box>
                              <Typography className="app_text_14_semibold"> Order Number </Typography>
                              <Typography className="app_text_12_fw500 app_text_gray"> {orderDetailData?.order_id} </Typography>
                           </Box>
                           {/* <Box>
                              <Typography className="app_text_14_semibold"> Payment Type </Typography>
                              <Typography className="app_text_12_fw500 app_text_gray"> {orderDetailData?.payment_type} </Typography>
                           </Box> */}
                           <Box>
                              <Typography className="app_text_14_semibold"> Date </Typography>
                              <Typography className="app_text_12_fw500 app_text_gray"> {moment(orderDetailData?.createdAt).format("DD MMM YYYY")} </Typography>
                           </Box>
                           {
                              orderDetailData?.verification_otp ?
                                 <Box>
                                    <Typography className="app_text_14_semibold"> Verification OTP </Typography>
                                    <Typography className="app_text_12_fw500 app_text_gray"> {orderDetailData?.verification_otp} </Typography>
                                 </Box> : ''
                           }
                           <Box>
                              <Typography className="app_text_14_semibold"> {orderDetailData.mobile ? "Phone Number" : "Email"} </Typography>
                              <Typography className="app_text_12_fw500 app_text_gray">
                                 {orderDetailData?.mobile
                                    ? orderDetailData?.mobile
                                    : orderDetailData?.email}
                              </Typography>
                           </Box>
                           {
                              orderDetailData?.is_pickup === false ?
                                 <Box>
                                    <Typography className="app_text_14_semibold"> Deliver to </Typography>
                                    <Typography className="app_text_12_fw500 app_text_gray"> {orderDetailData?.delivery_address} </Typography>
                                 </Box> : ''
                           }
                           {
                              orderDetailData?.is_pickup === false ?
                                 <Box>
                                    <Typography className="app_text_14_semibold"> Delivery Provider</Typography>
                                    <Typography className="app_text_12_fw500 app_text_gray"> {`${orderDetailData.delivery_by == 0 ? "Binox Delivery" : orderDetailData.delivery_by == 1 ? "Self Delivery" : ""}`} </Typography>
                                 </Box> : ''
                           }
                        </Stack>
                     </Box>
                  </Grid>
                  <Grid item xs={12}>
                     <Typography className="app_text_16_semibold"> Bill Details </Typography>
                     <Box
                        sx={{
                           border: "1px solid gainsboro",
                           // padding: "16px",
                        }}
                     >
                        <Table>
                           <StyledTableRow>
                              <TableCell>
                                 <Typography className="app_text_14_semibold"> Item Total </Typography>
                              </TableCell>
                              <TableCell align="right">
                                 <Typography className="app_text_14_semibold"> £{orderDetailData?.sub_total?.toFixed(2)} </Typography>
                              </TableCell>
                           </StyledTableRow>
                           <StyledTableRow>
                              <TableCell>
                                 <Typography className="app_text_14_semibold"> Tax </Typography>
                              </TableCell>
                              <TableCell align="right">
                                 <Typography className="app_text_14_semibold"> £{orderDetailData?.tax?.toFixed(2)} </Typography>
                              </TableCell>
                           </StyledTableRow>
                           {
                              orderDetailData?.is_pickup === false ?
                                 <StyledTableRow>
                                    <TableCell>
                                       <Typography className="app_text_14_semibold"> Delivery Charge </Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                       <Typography className="app_text_14_semibold"> £{orderDetailData?.delivery_charge?.toFixed(2)} </Typography>
                                    </TableCell>
                                 </StyledTableRow> : ''
                           }

                           <TableRow> <TableCell colSpan={2}></TableCell> </TableRow>

                           <TableRow>
                              <TableCell style={{ borderBottom: "0" }}>
                                 <Typography className="app_text_14_semibold"> Total </Typography>
                              </TableCell>
                              <TableCell align="right" style={{ borderBottom: "0" }}>
                                 <Typography className="app_text_14_semibold"> £{orderDetailData?.total_amount?.toFixed(2)} </Typography>
                              </TableCell>
                           </TableRow>
                        </Table>
                     </Box>
                  </Grid>
               </Grid>
            </DialogContent>

            <DialogActions sx={{ boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.5)' }}>
               <Stack direction={"row"} spacing={2}>
                  {
                     orderDetailData?.status === 0 &&
                     <Button className="text-white app_bg_primary app_text_14_500 p-2 text-capitalize" variant="contained" component="label" style={{ "borderRadius": 5 }} onClick={(e) => handleAcceptAlert(orderDetailData, 1)}>
                        Accept Order
                     </Button>
                  }
                  <Button onClick={handleCloseOrderView} aria-label="delete" className="p-2 app_bg_primary_light  text-capitalize" style={{ borderRadius: '5px' }} variant="contained">
                     Close
                  </Button>
               </Stack>
            </DialogActions>
         </Dialog>
         {/* Pickup Order Dialoge */}
         <Dialog
            open={openPickupDialog}
            onClose={handleClosePickUpOrder}
            aria-labelledby="child-modal-title"
            aria-describedby="child-modal-description"
         >
            <DialogTitle>
               <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                  <h4>Order PickUp Time</h4>
                  <Button className="dashboard_light_bg_icon_btn" onClick={handleClosePickUpOrder} aria-label="delete">
                     <CloseIcon style={{ color: '#fff' }} />
                  </Button>
               </Box>
            </DialogTitle>
            <DialogContent className="custom_form_mui pt-2" sx={{ minWidth: '400px' }}>
               <FormikProvider value={formik}>
                  <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                     <div className="row">
                        <div className="col-lg-6">
                           <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                                 disablePast
                                 // minTime
                                 label="PickUp Start Time"
                                 value={pickupStartTime}
                                 onChange={(e) => { handlePickupStartTime(e) }}
                                 renderInput={(props) => <TextField {...props}
                                    name="pickup_start_time"
                                    {...getFieldProps("pickup_start_time")}
                                    error={Boolean(touched.pickup_start_time && errors.pickup_start_time)}
                                    helperText={touched.pickup_start_time && errors.pickup_start_time}
                                 />}
                              />
                           </LocalizationProvider>
                        </div>
                        <div className="col-lg-6">
                           <LocalizationProvider dateAdapter={AdapterDayjs}>
                              <DateTimePicker
                                 disablePast
                                 label="PickUp End Time"
                                 value={pickupEndTime}
                                 onChange={(e) => { setPickupEndTimeValue(e) }}
                                 renderInput={(props) => <TextField {...props}
                                    name="pickup_end_time"
                                    {...getFieldProps("pickup_end_time")}
                                 />}
                              />
                              <FormHelperText error>{errors.pickup_end_time}</FormHelperText>
                           </LocalizationProvider>
                        </div>
                     </div>
                     <div className="col">
                        <div className="col-md-8 m-auto">
                           <LoadingButton
                              type='submit'
                              fullWidth
                              className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                              loading={buttonLoading}
                              loadingPosition="end"
                              variant="contained"
                           >
                              submit
                           </LoadingButton>
                        </div>
                     </div>
                  </Form>
               </FormikProvider>
            </DialogContent>
         </Dialog>
      </>
   )
}

export default PendingOrder